

exports.__esModule = true;

require('./directive');

require('components/xo-wallet-components/src/add-bank/route');

var _squid = require('squid');

exports['default'] = _squid.$Route.extend('$SidebarUpdateCardRoute', {

    params: {
        planId: null
    },
    path: 'sidebarUpdateCard',
    directive: 'xo-sidebar-update-card',
    titleContent: 'asideHeader.updateCard',
    trackingData: {
        templateName: 'tray/updateCard.dust',
        pageGoal: 'update Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-update-cc',
                'pagename2': '%::fullpage-update-cc:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks',
            logout: 'logout',
            fundingid: 'fundingid'
        }
    }]
});


_squid.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-update-card/route.js
// module id = ./pages/xo-sidebar-update-card/route.js
// module chunks = 1